import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const conceptRoute = {
    LIST_CONCEPT_BY_PRODUCT: "dashboard/billing/concept/list-by-products"
}
export default {
    listByProduct(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(conceptRoute.LIST_CONCEPT_BY_PRODUCT, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron productos de esta compañia");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los productos");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
}